(function() {
    'use strict';

    angular.module('ecrd.states')
        .controller('LockInfoController', LockInfoController);

    LockInfoController.$inject = ['RecordMetadataService', 'CrdConfigurationService'];

    function LockInfoController(RecordMetadataService, CrdConfigurationService) {
        var vm = this;

        // Datos informativos (valor, usuario, fecha, firma)
        vm.info = {};

        var _eventListeners = [];

        vm.label = CrdConfigurationService.getLabelSingular();

        vm.$onInit = function() {
            if (vm.formId) {
                vm.info = RecordMetadataService.getFormLock(vm.formId, vm.listIndices);
            } else {
                vm.info = RecordMetadataService.getGlobalLock();
            }

            _setUpListeners();
        };

        vm.$onDestroy = function() {
            if (vm.formId) {
                _tearDownListeners();
            }
        };

        function _setUpListeners() {
            var handler;

            if (vm.formId) {
                handler = function() {
                    vm.info = RecordMetadataService.getFormLock(vm.formId, vm.listIndices);
                };
            } else {
                handler = function() {
                    vm.info = RecordMetadataService.getGlobalLock();
                };
            }

            _eventListeners.push(RecordMetadataService.events.on('load', handler));
        }

        function _tearDownListeners() {
            angular.forEach(_eventListeners, function(deregister) {
                deregister();
            });
        }

    }
})();
